// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/Dropdown.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Staatliches-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Staatliches-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Circular_regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Staatliches';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-display: swap;
  font-weight: normal;
}

@font-face {
  font-family: 'Staatliches2';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-display: swap;
  font-weight: normal;
}

@font-face {
  font-family: 'Circular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-display: swap;
  font-weight: normal;
}

html {
  background-color: var(--blassgruen);
}

/* Farben laufen über Vererbung vom body (statt color auf * und div):
   so erbt jede Komponente vorhersagbar Dunkelgrün und kann es gezielt
   überschreiben, ohne sich gegen globale Element-Selektoren zu stemmen. */
* {
    font-family: 'Staatliches', sans-serif;
    font-weight: normal;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-size: 1em;
}

body {
  margin: 0;
  padding: 0 20px 20px;
  min-height: 100dvh; /* statt height:92dvh — Workaround, der je nach Seite Platz verschluckte */
  text-align: center;
  color: var(--dunkelgruen);
}

ul {
    list-style-type: none; 
}

a, a:visited{
    text-decoration: none;
}

/* Ohne die frühere *-Farbregel würden klassenlose Links (z. B. in Tabellen)
   aufs Browser-Blau/Lila zurückfallen — sie erben jetzt die Umgebungsfarbe.
   Bewusst nur auf \`a\` (0,0,1), NICHT auf \`a:visited\` (0,1,1): sonst würde
   :visited jede Klassen-Farbe wie .home_button überstimmen. Die UA-:visited-
   Farbe wird trotzdem überschrieben (Autor-Styles schlagen UA-Styles). */
a {
    color: inherit;
}

input[type="text"]:not(.freitext-input),
textarea:not(.freitext-input),
select:not(.freitext-input) {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1.5px solid var(--primary-dark);
  border-radius: 10px;
  font-size: 20px;
  color: var(--primary-dark);
  background-color: var(--hellgruen);
  font-weight: normal;
}

input[type="text"],
select,
textarea {
  font-weight: normal;
}

input[type="text"]::placeholder,
textarea::placeholder,
select::placeholder {
  font-weight: normal;
  color: var(--placeholder);
}

p, strong, a {
  -webkit-font-smoothing: antialiased;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-weight: normal;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
}

h1 {
  color: var(--hellblau);
  font-size: 2em;
  text-align: left;
  padding-bottom: 10px;
}

.page-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}

body.Zeltbetreuung h1 {
  color: var(--dunkelgruen);
}

body.Logistik h1 {
  color: var(--mittelblau);
}

body.Parlament h1 {
  color: var(--gelb);
}

body.Arbeit-Freizeit h1 {
  color: var(--orange);
}

h2 {
  font-size: 1.5em;
  color: var(--dunkelgruen);
  text-align: center;
  margin-top: 20px;
}

select {
  appearance: none;
  width: 100%;
  padding: 15px;
  border: none;
  background-color: #dfe6a7;
  color: #757c5b;
  border-radius: 10px;
  margin-bottom: 15px;
}

select:disabled {
  opacity: 0.5;
}

@media print {
  .no-print {
    display: none;
  }
  * {
    -webkit-print-color-adjust: economy;
    color: black;
    font-family: arial;
    background-color: white;
  }
}

button {
  background-color: var(--dunkelgruen);
  color: white;
  display: block;
  width: 100%;
  padding: 15px;
  font-weight: normal;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 20px;
}

button:disabled {
  background-color: rgba(180, 200, 130, 0.5);
  color: gray;
  cursor: not-allowed;
}

button:hover {
  opacity: 0.8;
}

/* Button-Hierarchie: Standard-button = Primäraktion (dunkelgrün, gefüllt).
   .btn-secondary = Neben-/Zurück-Aktion (Outline), .btn-danger = destruktiv. */
button.btn-secondary {
  background-color: transparent;
  color: var(--dunkelgruen);
  border: 2px solid var(--dunkelgruen);
}

button.btn-danger {
  background-color: var(--blutorange);
}

label {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-weight: normal;
  color: #1b3c9c;
  margin-bottom: 5px;
}

/* Table styles */

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
}

th {
  background-color: var(--orange);
  color: white;
  text-align: left;
  width: 50%;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

tr {
  background-color: var(--hellgruen);
}

/* Add styles for checkboxes */
input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--primary-dark); /* Optional: Set checkbox color */
  -webkit-appearance: auto; /* Allow native styles for form elements */
}

select {
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--placeholder);
}

.clickable-text {
  text-decoration: underline;
  text-underline-offset: 4px;
}

/* Styles for dropdown with chevron */
.dropdown-wrapper {
  position: relative;
  display: block; /* Make the wrapper take up the full width of its container */
  margin-top: 4px; /* Optional: space between label text and dropdown */
}

.dropdown-wrapper select {
  width: 100%;
  padding: 10px 40px 10px 10px; /* give space for chevron */
  border: none;
  border-radius: 10px;
  background-color: var(--mittelgruen);
  appearance: none; /* Remove default browser arrow */
  -webkit-appearance: none; /* Safari and Chrome */
  -moz-appearance: none; /* Firefox */
  cursor: pointer;
  font-size: 1em; /* Match surrounding text if any */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
  line-height: 1.5; /* Ensure text is not cut off */
}

/* Hide default arrow in IE/Edge */
.dropdown-wrapper select::-ms-expand {
  display: none;
}

.dropdown-chevron {
  position: absolute;
  top: 35%;
  right: 10px; /* Adjust based on select's right padding */
  transform: translateY(-50%);
  pointer-events: none; /* So the icon doesn't interfere with select click */
  font-size: 1.8rem; /* Adjust size of the chevron icon */
  color: var(--dunkelgruen); /* Chevron color */
}

.bereich_button.Zeltbetreuung {
  background-color: var(--dunkelgruen);
}

.bereich_button.Parlament {
  background-color: var(--gelb);
}

.bereich_button.Logistik {
  background-color: var(--mittelblau);
}

.bereich_button.Arbeit-Freizeit {
  background-color: var(--orange);
}

.freitext-label {
  color: var(--dunkelgruen);
  font-family: "Staatliches", sans-serif;
  margin-bottom: 5px;
}

.freitext-input {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 15px;
  color: var(--dunkelgruen);
  font-family: "Circular", sans-serif;
  font-size: 1em;
}

.freitext-input::placeholder {
  color: var(--placeholder);
  opacity: 1;
}
/* Sichtbarer Tastatur-Fokus (A11y) */
:focus-visible {
  outline: 3px solid var(--mittelblau);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,0BAA0B;EAC1B,2DAAkE;EAClE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4DAAoE;EACpE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+DAAkE;EAClE,kBAAkB;EAClB,mBAAmB;AACrB;;AAKA;EACE,mCAAmC;AACrC;;AAEA;;0EAE0E;AAC1E;IACI,sCAAsC;IACtC,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,cAAc;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB,EAAE,0EAA0E;EAC9F,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;yEAIyE;AACzE;IACI,cAAc;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;+EAC+E;AAC/E;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC,EAAE,iCAAiC;EACpE,wBAAwB,EAAE,0CAA0C;AACtE;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,cAAc,EAAE,6DAA6D;EAC7E,eAAe,EAAE,oDAAoD;AACvE;;AAEA;EACE,WAAW;EACX,4BAA4B,EAAE,2BAA2B;EACzD,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB,EAAE,iCAAiC;EACnD,wBAAwB,EAAE,sBAAsB;EAChD,qBAAqB,EAAE,YAAY;EACnC,eAAe;EACf,cAAc,EAAE,kCAAkC;EAClD,sBAAsB,EAAE,uEAAuE;EAC/F,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,2CAA2C;EACxD,2BAA2B;EAC3B,oBAAoB,EAAE,oDAAoD;EAC1E,iBAAiB,EAAE,oCAAoC;EACvD,yBAAyB,EAAE,kBAAkB;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');\n\n@font-face {\n  font-family: 'Staatliches';\n  src: url('./assets/fonts/Staatliches-Regular.woff') format('woff');\n  font-display: swap;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Staatliches2';\n  src: url('./assets/fonts/Staatliches-Regular.woff2') format('woff2');\n  font-display: swap;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Circular';\n  src: url('./assets/fonts/Circular_regular.ttf') format('truetype');\n  font-display: swap;\n  font-weight: normal;\n}\n\n@import './styles/variables.css';\n@import \"./styles/Dropdown.css\";\n\nhtml {\n  background-color: var(--blassgruen);\n}\n\n/* Farben laufen über Vererbung vom body (statt color auf * und div):\n   so erbt jede Komponente vorhersagbar Dunkelgrün und kann es gezielt\n   überschreiben, ohne sich gegen globale Element-Selektoren zu stemmen. */\n* {\n    font-family: 'Staatliches', sans-serif;\n    font-weight: normal;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-size: 1em;\n}\n\nbody {\n  margin: 0;\n  padding: 0 20px 20px;\n  min-height: 100dvh; /* statt height:92dvh — Workaround, der je nach Seite Platz verschluckte */\n  text-align: center;\n  color: var(--dunkelgruen);\n}\n\nul {\n    list-style-type: none; \n}\n\na, a:visited{\n    text-decoration: none;\n}\n\n/* Ohne die frühere *-Farbregel würden klassenlose Links (z. B. in Tabellen)\n   aufs Browser-Blau/Lila zurückfallen — sie erben jetzt die Umgebungsfarbe.\n   Bewusst nur auf `a` (0,0,1), NICHT auf `a:visited` (0,1,1): sonst würde\n   :visited jede Klassen-Farbe wie .home_button überstimmen. Die UA-:visited-\n   Farbe wird trotzdem überschrieben (Autor-Styles schlagen UA-Styles). */\na {\n    color: inherit;\n}\n\ninput[type=\"text\"]:not(.freitext-input),\ntextarea:not(.freitext-input),\nselect:not(.freitext-input) {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1.5px solid var(--primary-dark);\n  border-radius: 10px;\n  font-size: 20px;\n  color: var(--primary-dark);\n  background-color: var(--hellgruen);\n  font-weight: normal;\n}\n\ninput[type=\"text\"],\nselect,\ntextarea {\n  font-weight: normal;\n}\n\ninput[type=\"text\"]::placeholder,\ntextarea::placeholder,\nselect::placeholder {\n  font-weight: normal;\n  color: var(--placeholder);\n}\n\np, strong, a {\n  -webkit-font-smoothing: antialiased;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  font-weight: normal;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n}\n\nh1 {\n  color: var(--hellblau);\n  font-size: 2em;\n  text-align: left;\n  padding-bottom: 10px;\n}\n\n.page-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n}\n\nbody.Zeltbetreuung h1 {\n  color: var(--dunkelgruen);\n}\n\nbody.Logistik h1 {\n  color: var(--mittelblau);\n}\n\nbody.Parlament h1 {\n  color: var(--gelb);\n}\n\nbody.Arbeit-Freizeit h1 {\n  color: var(--orange);\n}\n\nh2 {\n  font-size: 1.5em;\n  color: var(--dunkelgruen);\n  text-align: center;\n  margin-top: 20px;\n}\n\nselect {\n  appearance: none;\n  width: 100%;\n  padding: 15px;\n  border: none;\n  background-color: #dfe6a7;\n  color: #757c5b;\n  border-radius: 10px;\n  margin-bottom: 15px;\n}\n\nselect:disabled {\n  opacity: 0.5;\n}\n\n@media print {\n  .no-print {\n    display: none;\n  }\n  * {\n    -webkit-print-color-adjust: economy;\n    color: black;\n    font-family: arial;\n    background-color: white;\n  }\n}\n\nbutton {\n  background-color: var(--dunkelgruen);\n  color: white;\n  display: block;\n  width: 100%;\n  padding: 15px;\n  font-weight: normal;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\nbutton:disabled {\n  background-color: rgba(180, 200, 130, 0.5);\n  color: gray;\n  cursor: not-allowed;\n}\n\nbutton:hover {\n  opacity: 0.8;\n}\n\n/* Button-Hierarchie: Standard-button = Primäraktion (dunkelgrün, gefüllt).\n   .btn-secondary = Neben-/Zurück-Aktion (Outline), .btn-danger = destruktiv. */\nbutton.btn-secondary {\n  background-color: transparent;\n  color: var(--dunkelgruen);\n  border: 2px solid var(--dunkelgruen);\n}\n\nbutton.btn-danger {\n  background-color: var(--blutorange);\n}\n\nlabel {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  font-weight: normal;\n  color: #1b3c9c;\n  margin-bottom: 5px;\n}\n\n/* Table styles */\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 10px;\n}\n\nth {\n  background-color: var(--orange);\n  color: white;\n  text-align: left;\n  width: 50%;\n}\n\nth, td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\ntr {\n  background-color: var(--hellgruen);\n}\n\n/* Add styles for checkboxes */\ninput[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--primary-dark); /* Optional: Set checkbox color */\n  -webkit-appearance: auto; /* Allow native styles for form elements */\n}\n\nselect {\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: var(--placeholder);\n}\n\n.clickable-text {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n/* Styles for dropdown with chevron */\n.dropdown-wrapper {\n  position: relative;\n  display: block; /* Make the wrapper take up the full width of its container */\n  margin-top: 4px; /* Optional: space between label text and dropdown */\n}\n\n.dropdown-wrapper select {\n  width: 100%;\n  padding: 10px 40px 10px 10px; /* give space for chevron */\n  border: none;\n  border-radius: 10px;\n  background-color: var(--mittelgruen);\n  appearance: none; /* Remove default browser arrow */\n  -webkit-appearance: none; /* Safari and Chrome */\n  -moz-appearance: none; /* Firefox */\n  cursor: pointer;\n  font-size: 1em; /* Match surrounding text if any */\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n  line-height: 1.5; /* Ensure text is not cut off */\n}\n\n/* Hide default arrow in IE/Edge */\n.dropdown-wrapper select::-ms-expand {\n  display: none;\n}\n\n.dropdown-chevron {\n  position: absolute;\n  top: 35%;\n  right: 10px; /* Adjust based on select's right padding */\n  transform: translateY(-50%);\n  pointer-events: none; /* So the icon doesn't interfere with select click */\n  font-size: 1.8rem; /* Adjust size of the chevron icon */\n  color: var(--dunkelgruen); /* Chevron color */\n}\n\n.bereich_button.Zeltbetreuung {\n  background-color: var(--dunkelgruen);\n}\n\n.bereich_button.Parlament {\n  background-color: var(--gelb);\n}\n\n.bereich_button.Logistik {\n  background-color: var(--mittelblau);\n}\n\n.bereich_button.Arbeit-Freizeit {\n  background-color: var(--orange);\n}\n\n.freitext-label {\n  color: var(--dunkelgruen);\n  font-family: \"Staatliches\", sans-serif;\n  margin-bottom: 5px;\n}\n\n.freitext-input {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  margin-bottom: 15px;\n  color: var(--dunkelgruen);\n  font-family: \"Circular\", sans-serif;\n  font-size: 1em;\n}\n\n.freitext-input::placeholder {\n  color: var(--placeholder);\n  opacity: 1;\n}\n/* Sichtbarer Tastatur-Fokus (A11y) */\n:focus-visible {\n  outline: 3px solid var(--mittelblau);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
